import axios from "axios";
import { ENDPOINTS, getBaseURL } from "data/endpoints";
import { getAxios } from "utils/networkutils";
import { getIpqsToastMessage } from "utils/security-messages";

import { LoginRequestProps } from "./interface";

export const loginUserApi = async (payload: LoginRequestProps) => {
  try {
    const { data } = await axios.post(getBaseURL() + ENDPOINTS.LOGIN, payload);

    return data;
  } catch (e) {
    const message =
      getIpqsToastMessage(e.response?.data?.message) ??
      e.response?.data?.message;
    return {
      message,
      error: { message },
    }; //manually added error for error snackbar validation
  }
};

export const getUserGeoInfo = async () => {
  try {
    const { data } = await getAxios().get(ENDPOINTS.GEO_INFO);

    return data;
  } catch (e) {
    return undefined;
  }
};

export const getCountriesList = async () => {
  try {
    const { data } = await getAxios().get(
      getBaseURL() + ENDPOINTS.COUNTRIES_LIST,
    );

    return data.response;
  } catch (e) {
    return undefined;
  }
};
